import React, { useCallback } from 'react';
import { TouchableWithoutFeedback, Dimensions } from 'react-native';
import { Autocomplete, AutocompleteItem, Icon, IconElement, Text } from '@ui-kitten/components';
import trackerApi from '../../api/tracker';

// const tariffs = [
//   { title: 'تست' },
//   { title: 'Back to the Future' },
//   { title: 'The Matrix' },
//   { title: 'Inception' },
//   { title: 'Interstellar' },
// ];
const  width= Dimensions.get('window').width-40

const filter = (item, query): boolean => item.service_name.includes(query);

const StarIcon = (props): IconElement => (
  <Icon
    {...props}
    name='settings'
  />
);

export const AutocompleteSimpleUsageShowcase = ({model, setSelect}): React.ReactElement => {

  const [value, setValue] = React.useState(null);
  const [data, setData] = React.useState([]);
  const [services, setServices] = React.useState([])

  const getTariffs = async() =>{
    const response = await trackerApi.post('/client/tariff', {model});
    if(response.data.status){
      await setServices(response.data.allData)
      await setData(response.data.allData)
      console.log('Services ',response.data.allData.length);
    }
    else {
      showMessage({
        message: `خطای دیتابیس`,
        type: "danger",
        icon: AlertIcon
      });
    }
  }
  React.useEffect(()=>{
    getTariffs()
  },[])

  const onSelect = useCallback((index): void => {
    setValue(data[index].service_name);
    console.log(data[index]);
    setSelect(data[index]);
  }, [data]);

  const onChangeText = (query) => {
    setValue(query);
    console.log(services.length);
    console.log(services.filter(item => filter(item, query)));
    setData(services.filter(item => filter(item, query)));
  }

  const clearInput = (): void => {
    setValue('');
    setData(services);
    // setSelect()
  };

  const renderOption = (item, index): React.ReactElement => (
    <AutocompleteItem
      key={index}
      title={item.service_name}
      accessoryLeft={StarIcon}
    />
  );

  const renderCloseIcon = (props): React.ReactElement => (
    <TouchableWithoutFeedback onPress={clearInput}>
      <Icon
        {...props}
        name='close'
      />
    </TouchableWithoutFeedback>
  );

  return (
    <Autocomplete
      placeholder='انتخاب کنید'
      style={{margin:10, width: width*0.7}}
      value={value}
      placement='inner top'
      accessoryRight={renderCloseIcon}
      onChangeText={onChangeText}
      onSelect={onSelect}
      label={evaProps => <Text {...evaProps}>قطعه یا سرویس</Text>}

    >
      {data.map(renderOption)}
    </Autocomplete>
  );
};
